module.exports = __webpack_public_path__ + "img/logo.5dda42c6.png";